import React, {useEffect, useState} from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import {Typography} from '@material-ui/core';
import {filter} from 'rxjs/operators';
import {
    requestQuickTradeDirection
} from '../../../../stores/websocketStore/utils/outgoingMessages/quicktrade/tradedirection/requestQuickTradeDirection';
import {useWebsocketStore} from "../../../../stores/websocketStore/websocketProvider";

const values = ['LONG', 'SHORT'];

export default function PositionDirectionDropDown({symbol, dataSource, positionDirection, setPositionDirection}) {
    const [id, setId] = useState(new Date().getTime());
    const {quickTradeDirectionSubject} = useWebsocketStore();

    useEffect(() => {

        const subscription = quickTradeDirectionSubject.pipe(
            filter((msg) => {
               // console.log(msg);
                //console.log(id, symbol, dataSource);
                //console.log(equals);
                return parseInt(msg['id']) === id;// && symbol === msg['symbol']
                //&& dataSource === msg['dataSource']
            })
        ).subscribe((msg) => setPositionDirection(msg['tradeDirection']));

        return () => subscription.unsubscribe();
    }, []);

    useEffect(() => {
        if (symbol && dataSource) {
            requestQuickTradeDirection(symbol, dataSource, id);
        }
    }, [symbol, dataSource])

    return (
        <BuildDropDown
            positionDirection={positionDirection}
            setPositionDirection={setPositionDirection}
        />
    );
}

/*

class DropDown extends React.Component {
  constructor(props) {
    super(props);
    this.symbol = props.symbol;
    this.dataSource = props.dataSource;
    this.id = new Date().getMilliseconds();
    if (
      !isEmpty(this.symbol) &&
      !isEmpty(this.dataSource) &&
      this.symbol !== undefined &&
      this.dataSource !== undefined
    ) {
      requestQuickTradeDirection(this.symbol, this.dataSource, this.id);
    }
  }

  componentDidMount() {
    this.subscription = QuickTradeDirectionSubject.pipe(
      filter((msg) => {
        return (
          parseInt(msg['id']) === this.id &&
          this.props.symbol === msg['symbol'] &&
          this.props.dataSource === msg['dataSource']
        );
      })
    ).subscribe((msg) =>
      this.props.setPositionDirection(msg['tradeDirection'])
    );
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  render() {
    if (
      this.symbol !== this.props.symbol ||
      this.dataSource !== this.props.dataSource
    ) {
      this.symbol = this.props.symbol;
      this.dataSource = this.props.dataSource;
      requestQuickTradeDirection(this.symbol, this.dataSource, this.id);
    }

    return (
      <BuildDropDown
        positionDirection={this.props.positionDirection}
        setPositionDirection={this.props.setPositionDirection}
      />
    );
  }
}
*/

function BuildDropDown({positionDirection, setPositionDirection}) {
    return (
        <>
            <TextField
                select
                value={positionDirection}
                variant="outlined"
                size="small"
                style={{
                    //#43a047 is type of green
                    backgroundColor:
                        positionDirection === 'LONG'
                            ? '#43a047'
                            : positionDirection === 'SHORT'
                                ? 'red'
                                : 'white',
                    width: '100%',
                    color: 'blue',
                }}
                onChange={(ev) => setPositionDirection(ev.target.value)}
                label={
                    <Typography style={{fontSize: 10}}>Trade Direction</Typography>
                }
            >
                {values.map((option) => (
                    <MenuItem key={option} value={option}>
                        <Typography style={{fontSize: 9}}>{option}</Typography>
                    </MenuItem>
                ))}
            </TextField>
        </>
    );
}
